import "./src/styles/main.css"
import "./node_modules/swiper/css/swiper.css"
import "./node_modules/swiper/js/swiper.js"
import "./src/styles/plyr.css"